import { arrayAccessor } from "@mittwald/awesome-node-utils/misc/ArrayAccessor";
import type { MittwaldApi } from "../../api/Mittwald";
import { mittwaldApi } from "../../api/Mittwald";

export type EmailAddressApiData =
  MittwaldApi.Components.Schemas.De_Mittwald_V1_Mail_MailAddress;

export class EmailAddress {
  public readonly id: string;
  public readonly data: EmailAddressApiData;
  public readonly address: string;

  protected constructor(data: EmailAddressApiData) {
    this.data = Object.freeze(data);
    this.id = data.id;
    this.address = data.address;
  }

  public static fromApiData(data: EmailAddressApiData): EmailAddress {
    return new EmailAddress(data);
  }

  public static useTryLoadById(id: string): EmailAddress | undefined {
    const data = mittwaldApi.mailGetMailAddress
      .getResource({ path: { mailAddressId: id } })
      .useWatchData({ optional: true });

    return data ? EmailAddress.fromApiData(data) : undefined;
  }

  public static getEmailAddressComponents = (
    address: string = "",
  ): { local: string; domain: string } => {
    const parts = arrayAccessor(address.split("@"));
    return { local: parts.at(0), domain: parts.optionalAt(1) ?? "" };
  };

  public getDomainPart = (): string => {
    return EmailAddress.getEmailAddressComponents(this.address).domain;
  };
}

export default EmailAddress;
